import { useCompositionForm } from "@design-lab/entities/composition";
import { useIsSample } from "@design-lab/shared/lib/config";

const DEFAULT_CATALOG_ID = "G640";
const DEFAULT_COMPOSITION_ID = "9460"; // G640-White color

export function useIsInitialState() {
  const { form: compositionForm } = useCompositionForm();
  const isSample = useIsSample();

  const isInitialState = () => {
    if (isSample) {
      const compositions = compositionForm.getValues("addedCompositions");
      return compositions.length === 0;
    }

    // Get current compositions (API always returns at least G640)
    const compositions = compositionForm.getValues("addedCompositions");

    // More than one composition = user has added multiple products
    if (compositions.length > 1) {
      return false;
    }

    // Edge case: No compositions (brief moment during loading)
    // Treat as initial state
    if (compositions.length === 0) {
      return true;
    }

    // Normal case: Exactly one composition
    // Check if it's G640-White (the default starter product)
    const composition = compositions[0];
    if (!composition) {
      return true;
    }

    const isG640White =
      composition.catalogId === DEFAULT_CATALOG_ID && composition.id === DEFAULT_COMPOSITION_ID; // Must be White color

    if (!isG640White) {
      return false; // User has selected a different product or color
    }

    // Check if all quantities are zero
    const variants = composition.variants || {};
    const allQuantitiesZero = Object.values(variants).every(qty => qty === 0);

    // Initial state = G640-White with zero quantities
    return allQuantitiesZero;
  };

  return { isInitialState };
}
